@import (reference) '../constants/spacing.module.less';
@import '../app-brand/entities/entity-layer.module.less';

.search-area {
  padding: @space-16 @space-16 @space-4;
}

.search-expander {
  display: flex;
  border-radius: 4px;
  border: 1px solid var(--left-nav--advanced-search-form--border-color);
  width: 208px;

  &:hover {
    border-color: var(--left-nav--advanced-search-form--active-border-color);
    box-shadow: 0 0 0 1px var(--left-nav--advanced-search-form--active-shadow-color);
  }

  &:focus {
    border-color: var(--left-nav--advanced-search-form--active-border-color);
  }

  .search-box-wrapper {
    width: 100%;
    display: flex;
    flex-direction: row;
    background: var(--left-nav--advanced-search-form--background-color);
    border-radius: 4px;

    .search-input {
      flex-grow: 1;
      min-width: 0;
      border: none;
      font-size: 14px;

      &::placeholder {
        color: var(--left-nav--advanced-search-form--place-holder-color);
      }
    }
  }

  .cancel-button {
    display: flex;
    align-items: center;
    cursor: pointer;
    background: var(--left-nav--advanced-search-form--background-color);
    flex-shrink: 0;
    height: 22px;
    margin: @space-4;
    padding: @space-8;
    border-radius: 4px;

    &:hover {
      background: var(--left-nav--advanced-search-form--button-background-color);
    }
  }

  .icon-xmark {
    width: 10px;
    color: var(--left-nav--advanced-search-form--icon-xmark--color);
  }

  .search-button {
    position: relative;
    cursor: pointer;
    width: 32px;
    border: none;
    border-radius: 0 4px 4px 0;
    border-left: 1px solid var(--left-nav--advanced-search-form--button-border-color);
    transition: 300ms ease all;
    background: var(--left-nav--advanced-search-form--button-background-color);
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background: var(--left-nav--advanced-search-form--input-hover-background-color);
      border: none;
      border-left: 1px solid var(--left-nav--advanced-search-form--button-border-color);
      box-shadow: 0 1px 1px 0 var(--left-nav--advanced-search-form--button-shadow);
    }

    .search-icon {
      color: var(--left-nav--advanced-search-filter--search-icon--color);
      width: 16px;
      height: 16px;
    }
  }
}
